import React, { Component } from "react";
import { History, Location } from "history";
import withNavbar from "../../common/HOC/NavbarContainerHOC";
import Helmet from "react-helmet";
import ChangePassForm from "./ChangePassForm";
import { match } from "react-router";


interface Props {
  history: History;
  location: Location;
  match: match;
}
interface State {
  
}

const TITLE = 'Đổi mật khẩu';
class CreateUser extends Component<Props, State> {
  state = {
   
  };

  onChangeInput = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    } as any);
  };

  onChangeFileHandler = (file) =>{
  }
  render() {
    return (
      <div className="card">
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <div className="card-body">
          <ChangePassForm history={this.props.history}></ChangePassForm>
        </div>
      </div>
    );
  }
}



const createUserWithNavbar = withNavbar()(CreateUser);

export default createUserWithNavbar;
